import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var ImageIcon = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4ZM7,6A2,2,0,1,1,5,8,2,2,0,0,1,7,6ZM19.81,17.23a.88.88,0,0,1-.81.54H5a.87.87,0,0,1-.62-1.49L7,13.7a.85.85,0,0,1,.62-.26.87.87,0,0,1,.62.26l1.22,1.22,3.8-3.8a.88.88,0,0,1,1.24,0l5.16,5.16A.88.88,0,0,1,19.81,17.23Z"
}), 'ImageIcon');